// import { encode } from 'punycode'

export function applyPromoCode(orderId: string, promoCode: string) {
  return {
    method: 'POST',
    url: `${
      process.env.REACT_APP_ORIGIN
    }/orders/apply-promo-code/${orderId}?reason=${encodeURIComponent(
      promoCode,
    )}`,
  }
}

export function removePromoCode(orderId: string, promoCode: string) {
  return {
    method: 'DELETE',
    url: `${
      process.env.REACT_APP_ORIGIN
    }/orders/remove-promo-code/${orderId}?reason=${encodeURIComponent(
      promoCode,
    )}`,
  }
}

export function getOrderData(orderId: string) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/orders/${orderId}`,
  }
}
